export const UNCATEGORISED_EXPENSE_NAME = 'Uncategorised';
